import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useConfig } from "../../utils/useConfig"
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useMutation } from "react-query";
import { useData } from "../../utils/useData";
import { removeOffering } from "../../mutations/offerings/removeOffering";
import { toast } from "react-toastify";

export const useRemoveOffering = ( options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employerId, employer, allCardOfferings } = useData();

    return useMutation(async (offeringId: string) => {
        const { API_URL, token } = await getSafeSessionConfig(config, getToken);
        await removeOffering(API_URL, token, employerId, offeringId);
    }, {
        onSuccess: () => {
            toast.success('Card type disabled successfully');
            employer.refetch();
            allCardOfferings.refetch();
            options?.onSuccess?.();
        },
        onError: (error: Error, variables: string) => {
            console.error(`Error disabling ${variables} cards:`, error);
            toast.error('Failed to disable cards');
            options?.onError?.(error);
        }
    });
}